import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/codes',
    },
    {
      path: '/codes',
      name: 'CodeList',
      component: () => import('../views/CodeList.vue'),
    },
  ],
})
